export default (yearData) => {

  const c = {
    yearData
  }
  const init = () => {
    c.root = document.querySelector('.le-side-year').parentElement;

    buildAccordion();

    c.root.classList.remove('_skelton');
    c.root.removeAttribute('aria-hidden');
  }

  const buildAccordion = () => {
    const yearList = c.root.querySelector('.le-side-year__list');
    const yearListItem = yearList.firstElementChild;
    yearListItem.classList.remove('is-current');

    const fragmentElement = document.createDocumentFragment();
    c.yearData.forEach(yearInfoObj => {
      const cloneListItem = yearListItem.cloneNode(true);

      if (yearInfoObj.isCurrent) {
        cloneListItem.classList.add('is-current');

        const dropdownTargetText = c.root.querySelector('.le-side-dropdown__target-txt');
        if (dropdownTargetText) {
          dropdownTargetText.textContent = yearInfoObj.yearTxt;
        }
      }

      const linkStr = `${location.pathname}?year=${yearInfoObj.year}`;
      cloneListItem.querySelector('.le-side-year__link').href = linkStr;
      cloneListItem.querySelector('.le-side-year__link-txt').textContent = yearInfoObj.yearTxt;

      fragmentElement.appendChild(cloneListItem);
    });

    yearList.innerHTML = '';
    yearList.appendChild(fragmentElement);
  }

  init ();
}
